import React from 'react';
import { Info, X } from 'lucide-react';

// DTD (Date-to-Date) CATV customers pay for a package upfront for a fixed duration — there's
// no "next billing cycle" for a package_change request to apply on like there is for a
// regular/calendar-billed customer (see backend/routes/serviceRequests.js's
// isDeferredPackageChange, which exempts DTD from the deferred-scheduling flow entirely and
// would otherwise apply the change immediately against a package they already paid for). So
// instead of letting a DTD customer submit a package_change request, both portal entry points
// (CustomerPlansPage, CustomerRequests) show this instead and point them at their next renewal.
export default function DtdPlanChangeNotice({ onClose }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999, padding: 16,
    }} onClick={onClose}>
      <div style={{
        background: '#fff', borderRadius: 14, width: '100%', maxWidth: 360,
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)', padding: '22px 20px', position: 'relative',
      }} onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} aria-label="Close" style={{
          position: 'absolute', top: 12, right: 12, border: 'none', background: 'transparent',
          cursor: 'pointer', color: '#94a3b8', padding: 4,
        }}>
          <X size={18} />
        </button>
        <div style={{
          width: 46, height: 46, borderRadius: 12, background: '#dbeafe', display: 'flex',
          alignItems: 'center', justifyContent: 'center', marginBottom: 14,
        }}>
          <Info size={22} color="#2563eb" />
        </div>
        <div style={{ fontSize: '1.02rem', fontWeight: 800, color: '#1e293b', marginBottom: 6 }}>
          Available on your next renewal
        </div>
        <div style={{ fontSize: '.87rem', color: '#475569', lineHeight: 1.5 }}>
          Since you are a DTD (Date to Date) customer with advance renewal, you can select the package on your next renewal.
        </div>
      </div>
    </div>
  );
}
